<template>
  <section>
    <v-row class="pa-0">
      <v-col cols="12" lg="6" class="left pa-0">
        <div class="logo">
          <span class="d-sr-only">FINBRIDGE</span>
        </div>
      </v-col>
      <v-col cols="12" lg="6" class="right">
        <div class="logo">
          <span class="d-sr-only">FINBRIDGE</span>
        </div>
        <h1 class="main-text">정보주체의 개인정보∙연계정보<br />열람 등 청구 절차</h1>

        <div class="article">
          <h2>1. 개인정보∙연계정보의 열람, 정정·삭제, 처리정지, 동의철회 요구</h2>
          <p>정보주체는 자신의 개인정보∙연계정보에 대한 열람을 핀브릿지㈜(이하 회사)에게 요구할 수 있으며, 회사는 본인 확인을 위하여 주민등록증, 운전면허증, 여권 등을 통한 신분 확인절차를 이행하기 위해 신분증을 요구할 수 있습니다.</p>
          <p>제출서류를 작성하여 처리부서로 서면, 전화, 전자우편 등을 통하여 제출하시면 됩니다. 대리인이 신청하는 경우 위임장을 작성하고 신청인과 대리인의 신분증을 준비하여 요구서를 제출할 수 있습니다.</p>
          <p>회사는 요구서를 받은 날로부터 10일 이내에 열람의 허용여부, 열람일시, 열람장소 등을 결정하고 ‘개인정보(열람,열람, 정정·삭제, 처리정지, 동의철회) 통지서’를 청구인에게 송부합니다.</p>
          <p>정정·삭제 및 동의 철회 요구에 대해서는 다른 법령에 특별한 규정이 없는 한 지체 없이(정당한 사유가 없는 한 5일 이내) 해당 연계정보를 복구 불가능한 방법으로 파기하고 그 결과를 청구인에게 송부합니다.</p>
          <div class="line"></div>
          <h3>[제출서류 양식 다운로드]</h3>
          <div class="download">
            <span>개인정보∙연계정보 열람, 정정·삭제, 처리정지, 동의철회 요구서</span>
            <v-btn
              color="white"
              outlined
              rounded
              @click="downloadFile($event, '요구서.hwpx')"
              :data-ga-category="gaEvent.category.privacyRequest.name"
              :data-ga-label="gaEvent.category.privacyRequest.label1"
              :data-ga-action="gaEvent.actions.buttonClick"
            >요구서 다운로드</v-btn>
          </div>
          <div class="download">
            <span>위임장</span>
            <v-btn
              color="white"
              outlined
              rounded
              @click="downloadFile($event, '위임장.hwp')"
              :data-ga-category="gaEvent.category.privacyRequest.name"
              :data-ga-label="gaEvent.category.privacyRequest.label2"
              :data-ga-action="gaEvent.actions.buttonClick"
            >위임장 다운로드</v-btn>
          </div>
        </div>

        <div class="article">
          <h2>2. 정보주체의 요구 처리 거절 등에 대한 이의 제기</h2>
          <p>정보주체는 개인정보∙연계정보 열람, 정정·삭제, 처리정지, 동의철회에 대한 조치에 불만이 있거나 이의가 있을 경우에는 이의신청서를 작성하여 이의제기를 할 수 있습니다.</p>
          <p>핀브릿지㈜는 이의제기를 받은 날로부터 10일 이내에 이의제기 내용을 검토한 후, 그 결과에 따라 조치하고 개인정보∙연계정보(열람, 정정·삭제, 처리정지, 동의철회) 요구에 대한 결과 통지서에 따라 정보주체에게 안내 드립니다.</p>
          <div class="line"></div>
          <h3>[참조]</h3>
          <div class="download">
            <span>개인정보 열람 등 조치에 대한 이의신청서</span>
            <v-btn
              color="white"
              outlined
              rounded
              @click="downloadFile($event, '이의신청서.hwp')"
              :data-ga-category="gaEvent.category.privacyRequest.name"
              :data-ga-label="gaEvent.category.privacyRequest.label3"
              :data-ga-action="gaEvent.actions.buttonClick"
            >이의신청서 다운로드</v-btn>
          </div>
        </div>

        <div class="article">
          <h2>3. 개인정보 요구서에 대한 통지</h2>
          <p>정보주체가 별지 제1호 서식으로 제출한 개인정보∙연계정보 열람·정정·삭제·처리정지·동의철회 요구서에 대하여 핀브릿지㈜는 정보주체의 요구에 대한 결과를 정보주체에게 10일 이내 통지하여야 합니다. 개인정보처리자는 다음 각 호의 어느 하나에 해당하는 경우에는 정보주체에게 그 사유를 알리고 열람을 제한하거나 거절할 수 있습니다.</p>
          <ul class="clause">
            <li>1) 법률에 따라 열람이 금지되거나 제한되는 경우</li>
            <li>2) 다른 사람의 생명·신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우</li>
            <li>3) 공공기관이 다음 각 목의 어느 하나에 해당하는 업무를 수행할 때 중대한 지장을 초래하는 경우</li>
          </ul>
          <ul class="clause sub">
            <li>가. 조세의 부과·징수 또는 환급에 관한 업무</li>
            <li>나. 「초·중등교육법」및「고등교육법」에 따른 각급 학교,「평생교육법」에 따른 평생교육시설, 그 밖의 다른 법률에 따라 설치된 고등교육기관에서의 성적 평가 또는 입학자 선발에 관한 업무</li>
            <li>다. 학력·기능 및 채용에 관한 시험, 자격 심사에 관한 업무</li>
            <li>라. 보상금·급부금 산정 등에 대하여 진행 중인 평가 또는 판단에 관한 업무</li>
            <li>마. 다른 법률에 따라 진행 중인 감사 및 조사에 관한 업무</li>
          </ul>
        </div>

        <p class="copyright">© FINBRIDGE Co., Ltd. All rights reserved.</p>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import { GaTracking } from "@/mixins/index.js";

export default {
  mixins: [GaTracking],
  name: "PrivacyRequest",

  methods: {
    downloadFile(e, file) {
      this.gaTracking(e);
      let newWindow = window.open("about:blank");
      newWindow.location.href = `/doc/${file}`;
    }
  }
};
</script>

<style lang="scss" scoped>
section {
  width: 100vw;
  min-height: 100vh;
  .left {
    display: none;
    align-items: center;
    align-self: flex-start;
    position: sticky;
    top: 0;
    height: 100vh;
    .logo {
      width: 200px;
      height: 28.5px;
      background: url("~@/assets/new/logo_wordmark_b.svg") no-repeat 0 0;
      background-size: contain;
      margin-left: 20%;
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: $primary-color;
    color: white;
    padding: 32px 32px 0;
    .logo {
      display: block;
      width: 113px;
      height: 16.1px;
      background: url("~@/assets/new/logo_wordmark_w.svg") no-repeat 0 0;
      background-size: contain;
    }
    .main-text {
      margin-top: 64px;
      font-size: rem(28px);
      font-weight: 100;
      line-height: 1.5;
      letter-spacing: -1.5px;
    }
    .article {
      margin-top: 60px;
      word-break: keep-all;
      h2 {
        font-size: rem(16px);
        font-weight: 500;
        line-height: 1.5;
        letter-spacing: -0.6px;
        opacity: 0.9;
      }
      p {
        margin-top: 16px;
        font-size: rem(13px);
        font-weight: 300;
        line-height: 1.5;
        letter-spacing: -0.48px;
        opacity: 0.9;
      }
      h3 {
        font-size: rem(14px);
        font-weight: 500;
        line-height: 1.5;
        letter-spacing: -0.8px;
      }
      .line {
        width: 80px;
        height: 2px;
        background-color: white;
        margin: 32px 0 24px;
      }
      .download {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        margin-top: 16px;
        span {
          font-size: rem(13px);
          font-weight: 300;
          line-height: 1.5;
          letter-spacing: -0.48px;
          opacity: 0.9;
        }
        .v-btn {
          flex: none;
          margin-top: 8px;
          font-size: rem(12px);
          font-weight: 300;
        }
      }
      .clause {
        margin-top: 16px;
        padding: 0;
        list-style: none;
        li {
          font-size: rem(12px);
          font-weight: 300;
          line-height: 2;
          letter-spacing: -0.45px;
          opacity: 0.9;
        }
        &.sub {
          padding-left: 12px;
        }
      }
    }
    .copyright {
      margin-top: 60px;
      margin-bottom: 16px;
      font-size: rem(11px);
      opacity: 0.5;
    }
  }
  @include respond-to("large") {
    .left {
      display: flex;
    }
    .right {
      padding: 200px 10% 0;
      .logo {
        display: none;
      }
      .main-text {
        margin-top: 0;
        font-size: rem(48px);
        letter-spacing: -2.4px;
      }
      .article {
        margin-top: 100px;
        h2 {
          font-size: rem(20px);
        }
        p {
          margin-top: 20px;
          font-size: rem(16px);
        }
        h3 {
          font-size: rem(16px);
        }
        .line {
          width: 120px;
          height: 4px;
          margin: 48px 0 32px;
        }
        .download {
          flex-wrap: nowrap;
          margin-top: 20px;
          span {
            font-size: rem(16px);
          }
          .v-btn {
            margin-top: 0;
            margin-left: 24px;
            font-size: rem(18px);
            font-weight: 300;
          }
        }
        .clause {
          margin-top: 24px;
          li {
            font-size: rem(15px);
            line-height: 2.2;
          }
          &.sub {
            padding-left: 19px;
          }
        }
      }
      .copyright {
        margin-top: 120px;
        margin-bottom: 40px;
        font-size: rem(15px);
      }
    }
  }
}
</style>
